import(/* webpackMode: "eager", webpackExports: ["PageViewTracker"] */ "/vercel/path0/apps/marketing/components/marketing/site/page-view-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/apps/marketing/components/marketing/site/site-header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.4_@babel+core@7.29.6_@opentelemetry+api@1.9.1_@playwright+test@1.57.0_@types+_60efafe84f741a0d96b946e7d0822f28/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button","buttonVariants"] */ "/vercel/path0/packages/ui/src/button.tsx");
